import { objectToCamelCase, objectToSnakeCase } from '../utils'
import api from './api'
import commonCategories from './commonCategories'

export default class ExpenseCategory {
  static api = api.create(ExpenseCategory)
  static commonCategories = commonCategories

  static readOnlyFields = ['id']
  constructor(expenseCategory) {
    const {
      id = '',
      humanReadableId = '',
      name = '',
      descriptionHtml = '',
      documentationDescHtml = '',
    } = expenseCategory
    Object.assign(this, {
      id,
      humanReadableId,
      name,
      descriptionHtml,
      documentationDescHtml,
    })
  }

  static create(opts) {
    return new ExpenseCategory(opts)
  }

  static fromAPI(json) {
    return new ExpenseCategory(objectToCamelCase(json))
  }

  /**
   * Prep data for the API. Can elect to include or exlude specific fields.
   * The readOnlyFields are always excluded.
   **/
  static toAPI(expenseCategory, fields = [], excludeFields = []) {
    // By default, send the whole object
    let data = {}

    // If it's a partial update, get only the fields specified
    if (fields.length > 0) {
      fields.forEach(field => {
        data[field] = expenseCategory[field]
      })
    } else {
      data = expenseCategory
    }

    //
    excludeFields = [...ExpenseCategory.readOnlyFields, ...excludeFields]
    excludeFields.forEach(item => {
      delete data[item]
    })

    return objectToSnakeCase(data)
  }
  static checkIsInstance(obj, name) {
    if (!(obj instanceof ExpenseCategory)) {
      throw Error(`${name} must be an instance of the ExpenseCategory class.`)
    }
  }
}
